import React, { PureComponent } from 'react'
import { connect } from 'react-redux'

// actions
import { getCompany } from '../../../actions/company'
import { getReportingConfig, updateReportingConfig } from '../../../actions/reporting'
import { startLoading, stopLoading } from '../../../actions/loading'

import ReportingInfo from '../../../components/ReportingInfo'
import ContainerWithTitle from '../../HOC/ContainerWithTitle'
import EditableHOCWrapper from '../../HOC/EditableHOC'
import { Appcues } from '../../../utils/constants'

const ReportingInfoEditable = EditableHOCWrapper(ReportingInfo)

class ReportingInfoContainer extends PureComponent {
  componentDidMount() {
    this.props.dispatch(getCompany())
    this.props.dispatch(getReportingConfig('REPORTING'))
  }

  onSave = (data, afterOnSave) => {
    this.props.dispatch(startLoading())
    this.props.dispatch(updateReportingConfig(data, 'REPORTING')).then((response) => {
      Appcues.track('Reporting Info saved')
      afterOnSave(response)
      this.props.dispatch(stopLoading())
    })
  }

  render() {
    const { lastModified = null, reporting = {} } = this.props.reportingReducer

    return (
      <ReportingInfoEditable
        dataToEdit={reporting}
        onSave={this.onSave}
        lastModified={lastModified}
        dispatch={this.props.dispatch}
      />
    )
  }
}

const ReportingInfoWithTitle = ContainerWithTitle(ReportingInfoContainer, 'Reporting')
const ReportingInfoConnected = connect(({ dispatch, reportingReducer }) => ({
  dispatch,
  reportingReducer,
}))(ReportingInfoWithTitle)

export default ReportingInfoConnected



// WEBPACK FOOTER //
// ./src/containers/Settings/Company/ReportingInfo.js